import { Bars3Icon } from '@heroicons/react/24/outline'
import MenuCaddyLogo from 'assets/menu-caddy-logo.svg'
import Loader from 'components/Loader'
import { Notifications } from 'components/Notifications'
import Sidebar from 'components/Sidebar'
import { useGetUserQuery } from 'containers/auth/queries'
import { useRef, useState } from 'react'
import { Toaster } from 'react-hot-toast'
import { Link, useLocation } from 'react-router-dom'
import GuestRouter from 'router/guest'
import UserRouter from 'router/user'

function App() {
    const [showMenu, setShowMenu] = useState(false)

    const { pathname } = useLocation()

    const menuIconRef = useRef<HTMLButtonElement | null>(null)

    const { data: getUserData, isFetching: isGetUserFetching, isError: isGetUserError } = useGetUserQuery()

    const handleCloseMenu = () => {
        setShowMenu(false)
    }

    const renderMenu = () => {
        return (
            <div className='flex items-center'>
                <button ref={menuIconRef} onClick={() => setShowMenu(!showMenu)} className='ml-5 sm:hidden'>
                    <Bars3Icon className='w-7 text-primary hover:text-primary-hover' />
                </button>
            </div>
        )
    }

    const isAppOauthPage = pathname === '/app-oauth'

    const renderApp = () => {
        if (isGetUserFetching) return <Loader fullPage />
        if (isGetUserError || !getUserData) return <GuestRouter />
        return (
            <>
                {!isAppOauthPage && <Sidebar showMenu={showMenu} closeMenu={handleCloseMenu} menuIconRef={menuIconRef} />}
                <main className='sm:pl-48'>
                    <UserRouter />
                </main>
            </>
        )
    }

    const doWeDeffoHaveAUser = !!(!isGetUserFetching && !isGetUserError && getUserData)

    return (
        <div>
            <Toaster toastOptions={{ duration: 5000 }} />
            <header className='fixed top-0 w-full z-20 h-14 px-4 flex justify-between items-center bg-white border-b border-b-gray-300'>
                {isAppOauthPage ? (
                    <img src={MenuCaddyLogo} width='55px' />
                ) : (
                    <Link to='/' className='hover:no-underline'>
                        <img src={MenuCaddyLogo} width='55px' />
                    </Link>
                )}
                <div className='flex items-center'>
                    {doWeDeffoHaveAUser && !isAppOauthPage ? <Notifications /> : null}
                    {doWeDeffoHaveAUser && !isAppOauthPage ? renderMenu() : null}
                </div>
            </header>
            <div className='pt-14 min-h-[101dvh] sm:min-h-dvh'>{renderApp()}</div>
        </div>
    )
}

export default App
